import { render, staticRenderFns } from "./MedhopPagination.vue?vue&type=template&id=4f52117e"
import script from "./MedhopPagination.vue?vue&type=script&lang=js"
export * from "./MedhopPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports